module.exports = __webpack_public_path__ + "static/media/kashio-logo.23dd111d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/kashio-logo.png
// module id = 2234
// module chunks = 0